/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const fsrToggleQuickBuy = (e) => {
  let modal = e.parentElement.querySelector('.fsr-quickBuy-modal')
  if(e.classList.contains('fsr-quickBuy-close')){
    modal = e.parentElement
  } 

  if(modal.dataset.open === 'false') {
    modal.dataset.open = 'true'
    modal.style.display = 'block'
  } else {
    modal.dataset.open = 'false'
    modal.style.display = 'none'
  }
}

const fsrQuickBuySelect = (e) => { 
  let activeOption = e.parentElement.querySelector('.fsr-selected-option')
  activeOption.classList.remove('fsr-selected-option')
  e.classList.add('fsr-selected-option')
}

const fsrQuickBuyQuantity = (e,n) => {
  let input = e.parentElement.querySelector('input')
  if (parseInt(input.value) + parseInt(n) > 0) input.setAttribute('value', parseInt(input.value) + parseInt(n))
}

const fsrQuickBuy = (e) => {
  let modal = e.parentElement
  let options = modal.querySelectorAll('[data-option] .fsr-selected-option')
  let selectedOptions = []
  for (let i=0;i<options.length;i++) {
    options[i] = options[i].innerHTML
    selectedOptions.push(options[i].innerHTML.trim())
  }

  let variant = ''
  if(selectedOptions.length == 0){
    variant = modal.querySelector(`[data-option1="Default Title"]`)
  }else if(selectedOptions.length == 1){
    variant = modal.querySelector(`[data-option1="${selectedOptions[0]}"]`)
  }else if(selectedOptions.length == 2){
    variant = modal.querySelector(`[data-option1="${selectedOptions[0]}"][data-option2="${selectedOptions[1]}"]`)
  }else if(selectedOptions.length == 3){
    variant = modal.querySelector(`[data-option1="${selectedOptions[0]}"][data-option2="${selectedOptions[1]}"][data-option3="${selectedOptions[2]}"]`)
  }

  let quantity = parseInt(modal.querySelector('input').value)

  let formData = {
   'items': [{
    'id': parseInt(variant.dataset.variant),
    'quantity': quantity
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    let bubble = document.querySelector('.Header__CartDot')
    let count = parseInt(bubble.innerHTML)
    bubble.innerHTML = count + quantity
    if (e.dataset.cartpage == 'true') window.location.href = '/cart'
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });  
}




